<template>
  <div class="farm-layout" dir="rtl">
    <slot />
  </div>
</template>

<style>
@import url('https://fonts.googleapis.com/css2?family=Vazirmatn:wght@300;400;500;600;700;800;900&display=swap');

.farm-layout {
  font-family: 'Vazirmatn', 'IRANSans', system-ui, sans-serif;
  height: 100vh;
  overflow: hidden;
  background: #0f172a;
  direction: rtl;
}

.farm-layout body {
  margin: 0;
  padding: 0;
}

/* Leaflet overrides for RTL */
.leaflet-control-zoom {
  direction: ltr;
}

.leaflet-draw-toolbar {
  direction: ltr;
}

/* Custom scrollbar */
.farm-layout ::-webkit-scrollbar {
  width: 4px;
}

.farm-layout ::-webkit-scrollbar-track {
  background: transparent;
}

.farm-layout ::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 2px;
}
</style>
